module.exports = __webpack_public_path__ + "static/media/mainBedroom.b762463c.jpg";